import * as React from "react";
import { cn } from "../../lib/utils";

// function Input({ className, type, ...props }: React.ComponentProps<"input">) {
//   return (
//     <input
//       type={type}
//       data-slot="input"
//       className={cn(
//         "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground",
//         "flex h-9 w-full min-w-0 rounded-md border border-gray-200 px-3 py-1 text-base bg-white transition-[color,box-shadow] outline-none",
//         "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium",
//         "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
//         "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
//         "aria-invalid:ring-destructive/20 aria-invalid:border-destructive",
//         className
//       )}
//       {...props}
//     />
//   );
// }

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        data-slot="input"
        ref={ref}
        className={cn(
          "file:text-foreground placeholder:text-gray-400 selection:bg-primary selection:text-primary-foreground",
          "flex h-9 w-full min-w-0 rounded-md border border-gray-200 px-3 py-1 text-base bg-white transition-[color,box-shadow] outline-none",
          "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium",
          "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
          "aria-invalid:ring-destructive/20 aria-invalid:border-destructive",
          className
        )}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
